export default __webpack_public_path__ + "static/media/ic_mail_outline_48px.0c047bd2.svg";